const name = 'empty-set';


const contents = `
<circle cx="31" cy="41" r="17" fill="#FFF" fill-opacity="0"></circle>
<path d="M31 19.956c2.696 0 5.345.52 7.929 1.551 2.595 1.036 4.918 2.58 6.95 4.613 2.034 2.033 3.578 4.356 4.614 6.951 1.03 2.584 1.551 5.233 1.551 7.929 0 2.696-.52 5.345-1.551 7.929-1.036 2.595-2.58 4.918-4.613 6.95-2.033 2.034-4.356 3.578-6.951 4.614-2.584 1.03-5.233 1.551-7.929 1.551-2.696 0-5.345-.52-7.929-1.551-2.595-1.036-4.918-2.58-6.95-4.613-2.034-2.033-3.578-4.356-4.614-6.951-1.03-2.584-1.551-5.233-1.551-7.929 0-2.696.52-5.345 1.551-7.929 1.036-2.595 2.58-4.918 4.613-6.95 2.033-2.034 4.356-3.578 6.951-4.614 2.584-1.03 5.233-1.551 7.929-1.551zm0 6.189c-1.9 0-3.773.368-5.636 1.111-1.806.72-3.422 1.795-4.867 3.24-1.446 1.446-2.52 3.062-3.241 4.868-.743 1.863-1.111 3.735-1.111 5.636 0 1.9.368 3.773 1.111 5.636.72 1.806 1.795 3.422 3.24 4.867 1.446 1.446 3.062 2.52 4.868 3.241 1.863.743 3.735 1.111 5.636 1.111 1.9 0 3.773-.368 5.636-1.111 1.806-.72 3.422-1.795 4.867-3.24 1.446-1.446 2.52-3.062 3.241-4.868.743-1.863 1.111-3.735 1.111-5.636 0-1.9-.368-3.773-1.111-5.636-.72-1.806-1.795-3.422-3.24-4.867-1.446-1.446-3.062-2.52-4.868-3.241-1.863-.743-3.735-1.111-5.636-1.111zM48.426 18.5l4.452 4.3-39.304 40.7-4.452-4.3 39.304-40.7z"/>
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;
